/* Central reviews - theme-owned widget (no app dependency).
   Fetches product reviews directly from the external endpoint per product,
   for every .cr-reviews-widget element found on the page, and renders a
   summary + swiper matching the review-summary / swiper-reviews look and
   feel from https://www.vivapets.nl/nl/advantage/. */
   
(function () {
  var API_URL = 'https://www.centralbase.eu/common/shopify-endpoint/products_reviews.php';
  var sites_id = Number(window.themeSettings && window.themeSettings.sitesId) || 8;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function getAllProductReviews(sourceIds) {
    var language = (window.themeSettings && window.themeSettings.currentLanguage)
      ? window.themeSettings.currentLanguage.toLowerCase()
      : '';
    return fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product_source_ids: sourceIds, language: language, sites_id: sites_id })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to connect to API');
        }
        return response.json();
      })
      .catch(function (error) {
        console.error(error);
        return {};
      });
  }

  function ordinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  function formatReviewDate(dateStr) {
    var d = new Date(dateStr + 'T00:00:00');
    if (isNaN(d.getTime())) return dateStr;
    var day = d.getDate();
    return day + ordinalSuffix(day) + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function starIcon(color) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14" viewBox="0 0 1792 1792" class="cr-star" style="color:' + color + '"><path fill="currentColor" fill-rule="evenodd" d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5T1385 1619q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5T365 1569q0-6 2-20l86-500L89 695q-25-27-25-48 0-37 56-46l502-73L847 73q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"></path></svg>';
  }

  function buildStars(rating, filledColor, emptyColor) {
    rating = Math.round(Number(rating) || 0);
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += starIcon(i <= rating ? filledColor : emptyColor);
    }
    return html;
  }

  function buildSummaryHtml(data) {
    return ''
      + '<div class="review-summary">'
      +   '<div class="aggrating">'
      +     '<div class="aggrstr">'
      +       buildStars(data.average_rating, '#FFC107', '#E0E0E0')
      +       '<span style="padding: 0px 5px;">-</span>'
      +       '<span>' + data.total_reviews + ' reviews</span>'
      +     '</div>'
      +   '</div>'
      + '</div>';
  }

  function buildSwiperHtml(data, widgetIndex) {
    var slidesHtml = (data.reviews || []).map(function (review, i) {
      return ''
        + '<div class="swiper-slide" data-hash="sliderRV-' + widgetIndex + '-' + i + '">'
        +   '<div class="item-box">'
        +     '<div class="review-item">'
        +       '<div class="review-item__head">'
        +         buildStars(review.rating, '#007AFF', '#B6B9BB')
        +         '<span style="padding-left: 6px;">' + review.title + '</span>'
        +       '</div>'
        +       '<div class="review-item__body">' + review.desc + '</div>'
        +       '<div class="review-item__footer">'
        +         '<span class="review-author">Review Added By: <span><span class="item-author">' + review.name + '</span></span></span>'
        +         '<span>-</span>'
        +         '<span class="review-date"><time class="rdate">' + formatReviewDate(review.date) + '</time></span>'
        +       '</div>'
        +     '</div>'
        +   '</div>'
        + '</div>';
    }).join('');

    return ''
      + '<div class="swiper swiper-reviews preload-reviews">'
      +   '<div class="swiper-wrapper review-wrapper">' + slidesHtml + '</div>'
      +   '<div class="swiper-pagination review-pagination"></div>'
      + '</div>';
  }

  function initSwiper(el) {
    var swiperEl = el.querySelector('.swiper-reviews');
    if (!swiperEl || !window.Swiper) {
      return;
    }
    new window.Swiper(swiperEl, {
      cssMode: false,
      slidesPerView: 1,
      spaceBetween: 0,
      mousewheel: {
        forceToAxis: true
      },
      pagination: {
        el: swiperEl.querySelector('.review-pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 5
      },
      hashNavigation: {
        watchState: true
      },
      on: {
        init: function () {
          swiperEl.classList.remove('preload-reviews');
        }
      }
    });
  }

  function renderWidget(el, data, widgetIndex) {
    if (!data || data.status !== 'success' || !data.reviews || !data.reviews.length) {
      return;
    }
    el.innerHTML = buildSummaryHtml(data) + buildSwiperHtml(data, widgetIndex);
    initSwiper(el);
  }

  function initReviewWidgets() {
    var widgets = document.querySelectorAll('.cr-reviews-widget');
    var sourceIds = [];
    widgets.forEach(function (el) {
      var sourceId = el.dataset.sourceId;
      if (sourceId && sourceIds.indexOf(sourceId) === -1) {
        sourceIds.push(sourceId);
      }
    });
    if (!sourceIds.length) {
      return;
    }

    getAllProductReviews(sourceIds).then(function (allData) {
      widgets.forEach(function (el, index) {
        var sourceId = el.dataset.sourceId;
        if (!sourceId) {
          return;
        }
        renderWidget(el, allData[sourceId], index);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewWidgets);
  } else {
    initReviewWidgets();
  }
})();